import React from 'react';
import './aboutushero.scss';
// import backgroundImage from 'images/schemes/backgroundImage'; 

const Aboutushero = () => {
  return (
    <div className="hero-section">
      <div className="overlay"> 
        <div className="content">
          <h3>Listen our story</h3>
          <h1>About Us</h1>
        </div>
      </div>
    </div>
  );
}

export default Aboutushero;
